import { styled } from '@nykaa/ui-components';

export const Anchor = styled.a`
  line-height: 0;
  &:hover {
    box-shadow: ${({ theme }) => theme.elevations.shadow100};
    z-index: 1;
  }
`;
